import { MockHandler } from '@gv/triage-components';

import { MockItem } from 'types';
import { URL } from 'api/constants';

let listData: MockItem[] = [
  {
    id: 1234,
    clickRate: 72,
    responseRate: 30,
    name: 'Re-check',
    subscribers: 124,
    end: 1675756311000,
    start: 1675669911000,
  },
  {
    id: 4444,
    subscribers: 14,
    name: 'Black friday',
  },
  {
    id: 444234,
    clickRate: 45,
    subscribers: 78,
    name: 'Christmas',
    end: 1675756311000,
    start: 1675669911000,
  },
];

const searchFilter = (array: any[], value: string, search?: string) => {
  if (!search) {
    return array;
  }

  return array.filter((item) =>
    item[value].toLocaleLowerCase().includes(search.toLocaleLowerCase())
  );
};

export const mockApiHandlers: MockHandler[] = [
  {
    method: 'get',
    url: URL.MOCK_LIST,
    responseFunc: ({ data }) => ({
      data: searchFilter(listData, 'name', data?.search),
    }),
  },
  {
    method: 'get',
    url: URL.MOCK_DETAILS,
    responseData: {
      id: 444234,
      clickRate: 45,
      responseRate: 20,
      name: 'Christmas',
      end: 1675756311000,
      start: 1675669911000,
      messages: [
        {
          id: 1,
          thread_id: '',
          author_id: null,
          media_url: null,
          media_type: null,
          created_at: '1653849226323',
          updated_at: '1653849226323',
          msg_text: 'Hi! We have new Christmas discounts, call!',
        },
      ],
      subscribers: [
        {
          id: 1,
          click: true,
          response: false,
          name: 'Theresa Webb',
          type: 'CVT Team Lead',
          phone: '+17025550122',
        },
        {
          id: 2,
          click: true,
          response: true,
          type: 'pet owner',
          name: 'Jenny Wilson',
          phone: '+17025550122',
        },
        {
          id: 3,
          click: false,
          response: false,
          type: 'pet owner',
          name: 'Eleanor Pena',
          phone: '+17025550122',
        },
      ],
    },
  },
  {
    method: 'post',
    url: URL.MOCK_LIST,
    responseFunc: ({ data }) => {
      listData = [...listData, data];
      return { data };
    },
  },
  {
    method: 'patch',
    url: URL.MOCK_DETAILS,
    responseFunc: ({ data }) => {
      listData = listData.map((item) => {
        if (item.id === data.id) {
          return data;
        }
        return item;
      });
      return { data };
    },
  },
];
